// import * as types from './mutations-types'
import pointsMailApi from '../../../../../api/wx-member/points-mall/points-mall'

export default {
  purchaseOrder: ({commit}, data) => {
    return new Promise(resolve => {
      pointsMailApi.purchaseOrder(data)
        .then(result => {
          resolve(result)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/payment-details/store/actions.js